<template lang="pug">
.activities-location-info-window
  a.btn.btn-transparent.btn-icon.btn-xs.info-window-close(@click.prevent="onClose")
    i.hi.hi-10.hi-close

  .info-window-body.d-flex.align-items-start
    .info-window-avatar-wrapper
      slot(name="avatar")
    .info-window-content.d-flex.flex-column
      //- First row
      .info-window-row
        .info-window-details
          .info-window-details-cell
            slot(name="primary-detail")
            .info-window-project
              slot(name="secondary-detail")
            .info-window-task
              slot(name="tertiary-detail")
        .info-window-updated-text.pl-20
          p
            | Updated
            |
            slot(name="updated-at")
          slot(name="updated-btn")
      //- Second row
      .info-window-row(v-if="hasSlot('cell-one') || hasSlot('cell-two')")
        .info-window-details-cell(v-if="hasSlot('cell-one')")
          slot(name="cell-one")
        .info-window-details-cell(v-if="hasSlot('cell-two')")
          slot(name="cell-two")
      //- Third row
      .info-window-row(v-if="hasSlot('cell-three')")
        .info-window-details-cell
          slot(name="cell-three")
  .info-window-footer.info-window-list.hidden-xs
    .col-xs-12.visits
      .info-window-label
        slot(name="list-label")
    slot(name="list-items")
    slot(name="list-and-more")
  .info-window-footer
    .col-xs-12.text-center
      a.report-url(:href="reportUrl")
        | View job sites report
        i.hi.hi-right.hi-8
</template>

<script>
import { get, has } from 'lodash-es';

const SEARCH_HEIGHT_AND_MARGIN = 50 + 15;

export default {
  name: 'ActivitiesLocationInfoWindow',
  props: {
    reportUrl: {
      type: String,
    },
    map: {
      type: Object,
      default: null,
    },
    panByOffset: {
      type: Number,
      default: SEARCH_HEIGHT_AND_MARGIN * -1,
    },
  },
  async updated() {
    await this.updateMapPosition();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },

    hasSlot(slotName) {
      return has(this.$slots, slotName);
    },
    async getParentWrapper() {
      // We need to provide this hack, because otherwise the ghost
      // marker for clusters doesn't get to update the info window
      // in time before the `$el` is available.
      await this.$nextTick();

      return new Promise((resolve) =>
        setTimeout(() => {
          return get(this.$el, 'parentElement.parentElement.parentElement.parentElement', null);
        }, 100),
      );
    },
    async updateMapPosition() {
      const map = this.map;

      if (!map || !map.getDiv) {
        return;
      }

      await this.$nextTick();

      const mapDiv = map.getDiv();
      const infoWindow = await this.getParentWrapper();

      if (!infoWindow) {
        return;
      }

      const { top: mt } = mapDiv.getBoundingClientRect();
      const { top: it } = infoWindow.getBoundingClientRect();
      const isIntersectingWithSearch = it - mt < SEARCH_HEIGHT_AND_MARGIN;

      if (isIntersectingWithSearch) {
        map.panBy(0, this.panByOffset);
      }
    },
  },
};
</script>
